import { useEffect, useState } from "react";

/* Shared render/generation progress bar. Matches the Mist Music Studio +
   Text-to-Image look (dark track, black border, cyan->mint gradient) so every
   video/render screen is visually consistent — no more mixed spinners, step bars
   and a lone gold bar.

   - Determinate: pass a numeric `value` (0-100) — used where the backend reports
     real progress (e.g. the Music Visualizer's FFmpeg progress).
   - Indeterminate: omit `value` and it self-simulates a smooth climb (easing to
     ~92% while the job runs), identical to the music/image bars, instead of a
     bare spinner. */
export function RenderProgress({ value = null, label = "Rendering…", active = true, testid = "render-progress" }) {
  const determinate = typeof value === "number" && !Number.isNaN(value);
  const [sim, setSim] = useState(6);

  useEffect(() => {
    if (determinate || !active) return undefined;
    setSim(6);
    const id = setInterval(() => {
      setSim((p) => (p >= 92 ? 92 : p + Math.max(0.6, (92 - p) * 0.045)));
    }, 600);
    return () => clearInterval(id);
  }, [determinate, active]);

  const pct = determinate ? Math.max(3, Math.min(100, Math.round(value))) : Math.round(sim);

  return (
    <div className="w-full max-w-sm space-y-2" data-testid={testid}>
      <div className="w-full h-4 border-2 border-black bg-[#141414] overflow-hidden shadow-[3px_3px_0px_#000]">
        <div
          className="h-full bg-gradient-to-r from-[#00F5D4] to-[#9EFFB8] transition-all duration-700 ease-out"
          style={{ width: `${pct}%` }}
          data-testid={`${testid}-bar`}
        />
      </div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-white/60">{label} · {pct}%</p>
    </div>
  );
}

export default RenderProgress;
